import { ERROR_HANDLING_EXPERIENCE, HTTP_CODE } from '../../utils/redirector-utils';

function createErrorResponse(description) {
  return {
    shouldRedirect: false,
    isErrorStatus: true,
    httpCode: HTTP_CODE.NOT_FOUND,
    description,
    errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT,
  };
}

export function isHiddenBundle({ data, itemId }) {
  const { hideItem } = data?.product?.identifiers || {};
  if (hideItem?.toLowerCase() === 'true') {
    return createErrorResponse(`Item ${itemId} is hidden`);
  }
  return null;
}

export function isObsoleteBundle({ data, itemId }) {
  const { obsolete } = data?.product?.availabilityType || {};
  if (obsolete) {
    return createErrorResponse(`Item ${itemId} is obsolete`);
  }
  return null;
}